import { useQuery } from "@apollo/client";
import { GET_CAMPAIGNS, GET_CAMPAIGN } from "../api/campaigns";
import { isEligibleRegion } from "../utils/campaign-utils";

/**
 * 캠페인 리스트 조회 훅
 * @param upcomingDays 조회할 일수 (기본값: 14)
 * @returns 캠페인 리스트 데이터 및 로딩 상태
 */
export const useCampaigns = (upcomingDays: number = 14) => {
  const loadAddr = localStorage.getItem("loadAddr");
  const isEligible = isEligibleRegion(loadAddr);

  const { data, loading, error, refetch } = useQuery(GET_CAMPAIGNS, {
    variables: { upcomingDays },
    skip: !isEligible, // 성남/수원이 아니면 쿼리 호출하지 않음
    fetchPolicy: "network-only", // 항상 최신 데이터 조회
  });

  // 디버깅용 로그
  if (!loading && data) {
    console.log("[useCampaigns] 데이터 조회 완료:", {
      upcomingDays,
      isEligible,
      campaignsCount: data?.campaigns?.length || 0,
      campaigns: data?.campaigns?.map((c: any) => ({
        id: c.id,
        productName: c.productName,
        nearestRunStartAt: c.nearestRunStartAt,
        runsCount: c.runs?.length || 0,
      })),
    });
  }

  return {
    campaigns: data?.campaigns || [],
    loading,
    error,
    refetch,
    isEligibleRegion: isEligible,
  };
};

/**
 * 단일 캠페인 조회 훅
 * @param campaignId 캠페인 ID
 * @returns 캠페인 데이터 및 로딩 상태
 */
export const useCampaign = (campaignId: number) => {
  const { data, loading, error, refetch } = useQuery(GET_CAMPAIGN, {
    variables: { campaignId },
    fetchPolicy: "cache-and-network", // 캐시를 먼저 보여주되 네트워크 요청도 수행하여 최신 데이터 보장
    // 캐시 병합 전략은 App.tsx의 typePolicies에서 설정됨
  });

  return {
    campaign: data?.campaign || null,
    loading,
    error,
    refetch,
  };
};
